import { Row, Col } from "react-bootstrap";

import DashboardCard from "./components/DashboardCard";
import {
  FlagIcon,
  GameIcon,
  RoomIcon,
  TransactionIcon,
  UsersIcon,
} from "../../constants/icon_path";
import { ROUTE } from "../../constants/app_routes";
import { useDashboardQuery } from "../../graphql/apollo/query-hooks";

const Dashboard = () => {
  const { fetchDashboard } = useDashboardQuery();

  return (
    <div className="dashboard lao">
      <Row>
        <Col md="3" sm="4">
          <DashboardCard
            bg="primary"
            title="ລາຍການປະເທດ"
            icon={<FlagIcon />}
            number={fetchDashboard?.country}
            route={ROUTE.country}
          />
        </Col>
        <Col md="3" sm="4">
          <DashboardCard
            bg="secondary"
            title="ລາຍການຫ້ອງເກມ"
            icon={<RoomIcon />}
            number={fetchDashboard?.room}
            route={ROUTE.room}
          />
        </Col>
        <Col md="3" sm="4">
          <DashboardCard
            bg="warning"
            title="ລາຍການເດີມພັນ"
            icon={<GameIcon />}
            number={fetchDashboard?.bet}
            route={ROUTE.bet}
          />
        </Col>
        <Col md="3" sm="4">
          <DashboardCard
            bg="dark"
            title="ລາຍການສະມາຊິກ"
            icon={<UsersIcon />}
            number={fetchDashboard?.member}
            route={ROUTE.member}
          />
        </Col>
        <Col md="3" sm="4">
          <DashboardCard
            bg="danger"
            title="ລາຍການທຸລະກຳ"
            icon={<TransactionIcon />}
            number={fetchDashboard?.transaction}
            route={ROUTE.transaction}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
